import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react";
import Color from "@/tool/color";
import moIndustry from "../../../store/industry";

interface IProps {
  title: string;
  value: number;
  rank: number;
  max: number;
  mid: number;
  min: number;
  type?: string;
}
interface IState {}

const Dispach = (props: IProps, state: IState) => {
  const { title, value, rank, max, mid, min, type } = props;

  useEffect(() => {
    return () => {};
  }, []);

  const getBg = useMemo(() => {
    if (rank < 33.3) {
      return "green";
    } else if (rank < 66.6) {
      return "orange";
    } else {
      return "red";
    }
  }, [rank]);

  const getColor = useMemo(() => {
    if (rank < 33.3) {
      return Color.success;
    } else if (rank < 66.6) {
      return Color.secondary;
    } else {
      return Color.red;
    }
  }, [rank]);

  return (
    <section className="dispach-warp">
      <section className="position-con" style={{ left: `${rank}%` }}>
        <p
          className={getBg}
          style={{
            position: "relative",
            left: rank <= 10 ? `${30 - rank * 3.3}px` : "",
            right: rank >= 90 ? `${30 - (100 - rank) * 3.3}px` : 0,
          }}
        >
          <span>{rank}</span>
          <i>
            {type === "ratio"
              ? `${(value * 100).toFixed(1)}%`
              : value.toLocaleString()}
          </i>
        </p>
        <b style={{ borderBottomColor: getColor }}></b>
      </section>
      <p className="pic">
        <span></span>
        <span></span>
        <span></span>
      </p>
      <p className="mid">
        <span>两年内最低 0</span>
        <span>50 中等</span>
        <span>两年内最高 100</span>
      </p>
      <p className="bot">
        <span>
          {title}{" "}
          {type === "ratio"
            ? `${(min * 100).toFixed(1)}%`
            : min.toLocaleString()}
        </span>
        <span>
          {type === "ratio"
            ? `${(mid * 100).toFixed(1)}%`
            : mid.toLocaleString()}
        </span>
        <span>
          {type === "ratio"
            ? `${(max * 100).toFixed(1)}%`
            : max.toLocaleString()}
        </span>
      </p>
    </section>
  );
};

export default observer(Dispach);
